import type { DeepPartial } from '@luna/utils-ts';

import type { FrontendUserConfiguration } from './UserConfigurationTypes';
import {
    selectDeprecatedUserConfigurationById,
    updateDeprecatedUserConfiguration,
} from './UserConfiguration';

const FRONTEND_CONFIG_ID = 'frontend';

type FrontendUserConfigurationUtils = {
    userConfiguration?: FrontendUserConfiguration;
    updateUserConfiguration: (
        userConfiguration: DeepPartial<FrontendUserConfiguration>,
    ) => ReturnType<typeof updateDeprecatedUserConfiguration>;
};

export const getFrontendUserConfiguration = (): FrontendUserConfigurationUtils => {
    /**
     * We don't use hooks here, because in some contexts, provider is not present
     */
    const frontendUserConfiguration = selectDeprecatedUserConfigurationById(FRONTEND_CONFIG_ID);

    return {
        userConfiguration: frontendUserConfiguration as FrontendUserConfiguration | undefined,
        updateUserConfiguration: (userConfiguration) =>
            updateDeprecatedUserConfiguration({
                id: FRONTEND_CONFIG_ID,
                changes: userConfiguration,
            }),
    };
};
